import TeamMemberDetail from './TeamMemberDetail.model';

export interface IProofDocument {
    sourceRecordType: string;
    recordId: string;
    title: string;
    documentDate?: string;
    proofExcerpt: string;
    status: string;
}

export interface IScheduledMemberNeed {
    memberId: string;
    referenceDate?: string;
    ahcccsId: string;
    firstName: string;
    lastName: string;
    memberName: string;
    dob?: string;
    age: number;
    healthPlan: string;
    teamName: string;
    primaryProvider: string;
    appointmentId?: string;
    scheduledAppointmentDate: string;
    appointmentType: string;
    appointmentStatus: string;
    scheduledProvider: string;
    flaggedNeedCategories: string[];
    needSummary: string;
    proofDocuments: IProofDocument[];
}

export default interface ITeamMemberSummary {
    referenceDate?: string;
    totalScheduledMembersNext7Days: number;
    countOpenTcNoLicensedVisit: number;
    countInTcNotDischarged: number;
    countExpiredOrNotMetHedis: number;
    countMissingConsentOrCarePlan: number;
    countCanceledNeedingReschedule: number;
    scheduledMembersOpenTcNoLicensedVisit: IScheduledMemberNeed[];
    scheduledMembersInTcNotDischarged: IScheduledMemberNeed[];
    scheduledMembersExpiredOrNotMetHedis: IScheduledMemberNeed[];
    scheduledMembersMissingConsentOrCarePlan: IScheduledMemberNeed[];
    scheduledMembersCanceledNeedingReschedule: IScheduledMemberNeed[];
    allScheduledMembersWithNeeds: IScheduledMemberNeed[];
    TeamMemberDetail: TeamMemberDetail[] | null;
}

export default class TeamMemberSummary implements ITeamMemberSummary {
    referenceDate?: string;
    totalScheduledMembersNext7Days: number = 0;
    countOpenTcNoLicensedVisit: number = 0;
    countInTcNotDischarged: number = 0;
    countExpiredOrNotMetHedis: number = 0;
    countMissingConsentOrCarePlan: number = 0;
    countCanceledNeedingReschedule: number = 0;
    scheduledMembersOpenTcNoLicensedVisit: IScheduledMemberNeed[] = [];
    scheduledMembersInTcNotDischarged: IScheduledMemberNeed[] = [];
    scheduledMembersExpiredOrNotMetHedis: IScheduledMemberNeed[] = [];
    scheduledMembersMissingConsentOrCarePlan: IScheduledMemberNeed[] = [];
    scheduledMembersCanceledNeedingReschedule: IScheduledMemberNeed[] = [];
    allScheduledMembersWithNeeds: IScheduledMemberNeed[] = [];
    TeamMemberDetail: TeamMemberDetail[] | null = null;
}